export const preloadData = () => {
    const images = [
        // require("@/assets/images/backgrounds/SOMEIMAGE.jpg"),
    ];
    const fonts = [
        new FontFace(
            "AvenirNextCondensed-Heavy",
            `url(${require("@/fonts/AvenirNext-Heavy.woff2")}) format('woff2'), url(${require("@/fonts/AvenirNext-Heavy.woff")}) format('woff'), url(${require("@/fonts/AvenirNext-Heavy.ttf")}) format('truetype'))})`
        ),
        new FontFace(
            "AvenirNextCondensed-Medium",
            `url(${require("@/fonts/AvenirNextCondensed-Medium.woff2")}) format('woff2'), url(${require("@/fonts/AvenirNextCondensed-Medium.woff")}) format('woff'), url(${require("@/fonts/AvenirNextCondensed-Medium.ttf")}) format('truetype'))})`
        ),
        new FontFace(
            "AvenirNextCondensed-BoldItalic",
            `url(${require("@/fonts/AvenirNextCondensed-BoldItalic.woff2")}) format('woff2'), url(${require("@/fonts/AvenirNextCondensed-BoldItalic.woff")}) format('woff'), url(${require("@/fonts/AvenirNextCondensed-BoldItalic.ttf")}) format('truetype'))})`
        ),
        new FontFace(
            "AvenirNextCondensed-Bold",
            `url(${require("@/fonts/AvenirNextCondensed-Bold.woff2")}) format('woff2'), url(${require("@/fonts/AvenirNextCondensed-Bold.woff")}) format('woff'), url(${require("@/fonts/AvenirNextCondensed-Bold.ttf")}) format('truetype'))})`
        ),
        new FontFace(
            "AvenirNextCondensed-Medium",
            `url(${require("@/fonts/AvenirNextCondensed-Medium.woff2")}) format('woff2'), url(${require("@/fonts/AvenirNextCondensed-Medium.woff")}) format('woff'), url(${require("@/fonts/AvenirNextCondensed-Medium.ttf")}) format('truetype'))})`
        ),
    ];
    return {
        images,
        fonts
    };
};
